import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const icons = {
  brand: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  select: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  sku: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  store: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  )
};

const PlatformData = props => {
  const data = useStaticQuery(graphql`
    query PlatformDataQuery {
      allPlatformDataJson {
        edges {
          node {
            number
            label
          }
        }
      }
    }
  `);

  const iconKeys = ['brand', 'select', 'sku', 'store'];

  return (
    <section className="platform-data">
      <div className="container">
        <div className="platform-data-header">
          <h2 className="platform-data-title-cn">平台合作数据</h2>
          <p className="platform-data-title-en">Platform Cooperation Data</p>
        </div>
        <div className="platform-data_container">
          {data.allPlatformDataJson.edges.map(({ node }, idx) => (
            <div key={`platform-data-${idx}`} className="platform-data_card">
              <div className="platform-data_card_icon">
                {icons[iconKeys[idx]]}
              </div>
              <div className="platform-data_card_number">{node.number}</div>
              <div className="platform-data_card_label">{node.label}</div>
            </div>
          ))}
        </div>
        <p className="platform-data_desc">
          魔鬼鱼订货平台，总部位于上海浦东新区，是一家专注于宠物门店的B2B垂直供应链服务平台。
          与200+国内外品牌方/供应商达成深入合作，甄选1000+品牌，50000+sku数量，
          共与3万+宠物门店&amp;医院共同成长。
        </p>
      </div>
    </section>
  );
};

export default PlatformData;
